
class CrudActionService {
    constructor(crudNameSingular, crudNamePlural) {
        this.CRUD_NAME_SINGULAR = crudNameSingular;
        this.CRUD_NAME_PLURAL = crudNamePlural;
        this.CRUD_NAME_SINGULAR_CAPS = crudNameSingular.toUpperCase();
        this.CRUD_NAME_PLURAL_CAPS = crudNamePlural.toUpperCase();

        this.setupFetchActions();
        this.constructDispatches();
    }
    setupFetchActions = () => {
        this.constructConstName("FETCH", this.CRUD_NAME_PLURAL_CAPS);
        this.constructConstName("FETCH", this.CRUD_NAME_SINGULAR_CAPS);
        this.constructConstName("ADD", this.CRUD_NAME_SINGULAR_CAPS);
        this.constructConstName("UPDATE", this.CRUD_NAME_SINGULAR_CAPS);
        this.constructConstName("DELETE", this.CRUD_NAME_SINGULAR_CAPS);
    };

    constructConstName = (action, crudName) => {
        this[`${action}_${crudName}`] = `${action}_${crudName}`;
        this[`${action}_${crudName}_SUCCESS`] = `${action}_${crudName}_SUCCESS`;
        this[`${action}_${crudName}_FAILURE`] = `${action}_${crudName}_FAILURE`;
    };

    constructDispatches = () => {
        this.constructSingularDispatches();
        this.constructPluralDispatches();
    };

    constructSingularDispatches = () => {
        const dispatchesSingular = ['request', 'add', 'update', 'delete'];

        dispatchesSingular.forEach(d => {
            this[`${d}${this.CRUD_NAME_SINGULAR}`] = () => {
                const type = d === "request" ? "FETCH" : d;
                return {
                    type: `${type.toUpperCase()}_${this.CRUD_NAME_SINGULAR_CAPS}`
                };
            };

            this[`${d}${this.CRUD_NAME_SINGULAR}Success`] = (payload) => {
                const type = d === "request" ? "FETCH" : d;
                return {
                    type: `${type.toUpperCase()}_${this.CRUD_NAME_SINGULAR_CAPS}_SUCCESS`,
                    payload: payload
                };
            };

            this[`${d}${this.CRUD_NAME_SINGULAR}Failure`] = (error) => {
                const type = d === "request" ? "FETCH" : d;
                return {
                    type: `${type.toUpperCase()}_${this.CRUD_NAME_SINGULAR_CAPS}_FAILURE`,
                    payload: error
                };
            };
        });
    };

    constructPluralDispatches = () => {
        const dispatchesPlural = ['request'];

        dispatchesPlural.forEach(d => {
            const type = d === "request" ? "FETCH" : d;
            this[`${d}${this.CRUD_NAME_PLURAL}`] = () => {
                return {
                    type: `${type.toUpperCase()}_${this.CRUD_NAME_PLURAL_CAPS}`
                };
            };

            this[`${d}${this.CRUD_NAME_PLURAL}Success`] = (payload) => {
                const type = d === "request" ? "FETCH" : d;
                return {
                    type: `${type.toUpperCase()}_${this.CRUD_NAME_PLURAL_CAPS}_SUCCESS`,
                    payload: payload
                };
            };

            this[`${d}${this.CRUD_NAME_PLURAL}Failure`] = (error) => {
                const type = d === "request" ? "FETCH" : d;
                return {
                    type: `${type.toUpperCase()}_${this.CRUD_NAME_PLURAL_CAPS}_FAILURE`,
                    payload: error
                };
            };
        });
    };
}

export default CrudActionService;